
import s from './Alojamiento.module.css';
import Landscape from '../../assets/Biodiversity/Landscape.jpg';
import alojamiento1 from '../../assets/Alojamiento1.jpg';
import alojamiento2 from '../../assets/Alojamiento2.jpg';
import alojamiento3 from '../../assets/Alojamiento3.jpg';

const Alojamiento = () => {
  

  const backgroundImageStyle = {
    backgroundImage: `url(${Landscape})`,
  };

  return (
    <div className={s.bio}>
        
        <div className={s.bioContainer} style={backgroundImageStyle}>
            <div className={s.libro}>
                <img src={alojamiento1} alt="" className={s.bioimg} />
                <img src={alojamiento2} alt="" className={s.bioimg} />
                <img src={alojamiento3} alt="" className={s.bioimg} />
            </div>
        </div>
    </div>
  );
};

export default Alojamiento